var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_3128_77768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9498 5.01093C8.97664 5.01319 8.02735 4.71814 7.23602 4.16745V8.00811C7.23575 8.71945 7.01211 9.41374 6.595 9.99817C6.17789 10.5826 5.5872 11.0293 4.9019 11.2785C4.2166 11.5278 3.46937 11.5677 2.76011 11.3929C2.05086 11.2182 1.41339 10.837 0.932946 10.3005C0.452501 9.76405 0.151982 9.09774 0.0715716 8.39072C-0.00883868 7.6837 0.134693 6.96966 0.482974 6.34408C0.831255 5.7185 1.36768 5.21121 2.02054 4.89002C2.67339 4.56884 3.41154 4.44907 4.13629 4.54675V6.47847C3.80464 6.37705 3.44851 6.38011 3.11876 6.4872C2.789 6.59429 2.50248 6.79994 2.30012 7.07478C2.09776 7.34962 1.9899 7.6796 1.99195 8.01759C1.994 8.35559 2.10585 8.68431 2.31152 8.95681C2.5172 9.22932 2.80619 9.43167 3.13722 9.53498C3.46825 9.63829 3.82439 9.63726 4.15479 9.53206C4.48519 9.42685 4.77294 9.22283 4.97696 8.94915C5.18097 8.67547 5.29082 8.34611 5.29081 8.00811V0.5H7.23602C7.23467 0.659699 7.24843 0.819181 7.27713 0.976429C7.34473 1.32746 7.48527 1.6614 7.69017 1.95781C7.89507 2.25423 8.16001 2.50689 8.46879 2.70034C8.9081 2.98274 9.42315 3.13326 9.9498 3.13315V5.01093Z",
    fill: "url(#paint0_linear_3128_77768)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_3128_77768",
    x: 0.0498047,
    y: 0.5,
    width: 9.90039,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3128_77768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3128_77768",
    x1: 4.9998,
    y1: -1.48,
    x2: 4.9998,
    y2: 13.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACB30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.302269,
    stopColor: "#FEF9C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#C49530"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF8C4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.ae680958998f1e309049b99a498060cd.svg";
export { ForwardRef as ReactComponent };